<!-- action btns -->
<div class="tw-flex tw-items-center tw-gap-4 tw-flex-row tw-my-4 tw-ml-[.1rem]">
  <button
    mat-stroked-button
    [disabled]="refreshing"
    [ngClass]="{ 'tw-bg-gray-200 dark:tw-bg-gray-500': refreshing }"
    (click)="refreshData()">
    <mat-icon [ngClass]="{'rotate-icon': refreshing}">refresh</mat-icon>
    Refresh
  </button>
</div>

<div class="tw-bg-white dark:tw-bg-gray-800 tw-shadow-md tw-overflow-hidden">
  <div *ngIf="!refreshing && !hasData" class="tw-p-8 tw-text-center">
    <mat-icon class="tw-text-gray-400 tw-h-14 tw-w-14 tw-text-[56px]">cloud_download</mat-icon>
    <h2 class="tw-text-xl tw-font-semibold tw-text-gray-700 dark:tw-text-gray-300 tw-mb-2">
      No downloads yet
    </h2>
    <p class="tw-text-gray-500 dark:tw-text-gray-400 tw-mb-6">
      You haven't downloaded any data or subscribed to any data streams yet.
    </p>
  </div>

  <div class="tw-w-full tw-overflow-x-auto" [ngClass]="{ 'tw-hidden': !hasData }">
    <div class="tw-min-w-[1000px] tw-w-full tw-h-screen">
      <!-- AG-GRID Table -->
      <ag-grid-angular
        style="width: 100%; height: 100%;"
        [ngClass]="{'ag-theme-quartz': !(darkModeService.darkMode$ | async), 'ag-theme-quartz-dark': darkModeService.darkMode$ | async }"
        [columnDefs]="columnDefs"
        [tooltipShowDelay]="tooltipShowDelay"
        accentedSort="true"
        [defaultColDef]="defaultColDef"
        enableCellTextSelection="true"
        ensureDomOrder="true"
        suppressRowTransform="true"
        [serverSideDatasource]="serverSideDatasource"
        [rowModelType]="rowModelType"
        [cacheBlockSize]="cacheBlockSize"
        [getRowId]="getRowId"
        [context]="context"
        [maxConcurrentDatasourceRequests]="1"
        (storeRefreshed)="onStoreRefreshed($event)"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>
